


































import { defineComponent, PropType, ref, computed, watchEffect } from '@vue/composition-api';
import { FitHalfScreenDialogV2 } from '@tencent/wphk-ui';
import { TaskItem } from '@/types/task';
import Button from '@/components/common/button.vue';
import { biClick } from '@tencent/fit-bi-sdk';
import MultiQualTaskTips from './multi-qual-task-tips/index.vue';
import TaskJumpBtn from '../task-item/jump-btn.vue';
import { i18n } from '@/i18n';
import { useCouponTaskDialog } from '@/hooks/use-coupon-task-dialog';
import { useTaskJumpBtn } from '@/hooks/use-task-jump-btn';

export default defineComponent({
  name: 'TaskInfoDialog',
  components: {
    FitHalfScreenDialogV2,
    Button,
    MultiQualTaskTips,
    TaskJumpBtn,
  },
  props: {
    /** 任务信息 */
    taskInfo: {
      type: Object as PropType<TaskItem>,
      required: true,
    },
  },
  setup(prop) {
    const useTaskJumpBtnHook = ref();
    watchEffect(() => {
      useTaskJumpBtnHook.value = useTaskJumpBtn(prop.taskInfo);
    });
    const isShowJump = computed(() => useTaskJumpBtnHook.value.isShowJump);
    const beforeJump = computed(() => useTaskJumpBtnHook.value.beforeJump);

    /** 关闭详情全局弹窗 */
    const { hideDialog: hideTaskDetailDialog } = useCouponTaskDialog();
    /** 任务信息弹窗 */
    const taskInfoDialog = ref<InstanceType<typeof FitHalfScreenDialogV2> | null>(null);
    const taskDesc = computed(() => {
      const { finishCount, maxTimesPerStage, prizeCountPerTime } = prop.taskInfo;
      const finished = finishCount * prizeCountPerTime;
      const max = maxTimesPerStage * prizeCountPerTime;
      return i18n('可儲印花<span class=\"green\">max</span>個，已得<span class=\"green\">finished</span>個', { max, finished });
    });
    const taskInfoRule = computed(() => {
      const { maxTimesPerDay, prizeCountPerTime, rule } = prop.taskInfo;
      const dayCountText = maxTimesPerDay ? i18n('每天最多可獲得dayCount個', { dayCount: maxTimesPerDay * prizeCountPerTime }) : '';
      return rule + dayCountText;
    });
    return {
      isShowJump,
      beforeJump,
      taskDesc,
      taskInfoRule,
      taskInfoDialog,
      /** 打开任务规则弹窗 */
      showTaskInfo() {
        taskInfoDialog.value?.showDialog();
      },
      /** 关闭任务规则弹窗 */
      onClickCloseDialog() {
        taskInfoDialog.value?.hideDialog();
      },
      onClose() {
        biClick('task.rule_close', { ftaskName: prop.taskInfo.name });
        hideTaskDetailDialog();
      },
    };
  },
});
